 <template lang='pug'>
  #GPT.main-page.GPT-color.pb-0.pl-5.pr-3.scrollbar.threadanalysis_height_100vh()
    loadingOverlay(v-show='loading' message='Loading . . .' :zIndex='999')
    div().d-flex.align-start.justify-start.pl-4.mt-1
      v-breadcrumbs.pa-0.pr-3.ellipsis()
        v-breadcrumbs-item(v-for="item in breadcrumbs" :key="item.text" )
          .detail_a
            a(:href='item.href')
              v-icon(size='23' style='margin-bottom:2px;').pr-1 mdi-chevron-double-left
              span {{item.text}}
    // 標題行
    v-row.d-flex.align-center.justify-md-space-between
      v-col.d-flex.align-center.px-0.pb-0(cols='4' md='6' )
        span.ml-2.mr-6(style='font-weight: 700; font-size: 28px;') {{$t('GPT_THREAD_ANALYSIS.THREAD_ANALYSIS')}}
    #page-inner.pb-0.height_100vh
      .knowledge_height(v-if='!loading')
        v-row.ma-0.pa-0.d-flex.justify-start
          v-col(cols='7').pa-0.pt-3
            v-row.ma-0.pa-0.d-flex.justify-start
              //日期
              v-col(cols='3' style="max-width:182px").px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.DATE')}}
                v-select.bg-white.my-chips-select(v-model='selected_date_type' height='30' my-chip dense chips outlined  :placeholder='$t("GPT_USER_ANALYSIS.DATE")' :items='date_cate' item-value='date' item-text='name')
                  template(v-slot:selection="{ item, index }")
                    v-chip(v-if="index === 0")
                      span {{ item.name }}
              //日期Picker
              v-col(cols='4' v-if="selected_date_type === 4" ).px-0.ml-2
                template(v-if="selected_date_type === 4")
                  v-menu(
                    min-width='496px'
                    ref="menu"
                    :close-on-content-click="false"
                    transition="scroll-y-transition"
                    offset-y
                  )
                    template(v-slot:activator="{ on, attrs }")
                      v-text-field.pt-0(
                        v-model='selectDateText'
                        :title='selectDateText'
                        v-bind="attrs"
                        v-on="on"
                        flat
                        dense
                        outlined
                        background-color="white"
                        prepend-inner-icon='mdi-calendar-multiple'
                      )
                    date-picker(
                      v-model='selectDate'
                      type="date"
                      range
                      inline
                      :showSecond='false'
                      value-type='format'
                      format='YYYY-MM-DD'
                      @change="dateChange($event)"
                    )
              //類別
              v-col(cols='4').px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.CATEGORY')}}
                v-select.bg-white.my-chips-select(v-model='selected_topic' height='10'  my-chip dense chips outlined  :placeholder='$t("GPT_USER_ANALYSIS.CATEGORY")' :items='topic_list' item-value='id' item-text='name')
                  template(v-slot:selection="{ item, index }")
                    v-chip.ellipsis-single.ml-2.knowledgelib-in-threadanalysis-chip(v-if="index === 0")
                        span  {{ item }}
              //有幫助
              v-col(cols='3').px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.HELPFUL')}}
                v-select.bg-white.my-chips-select(v-model='selected_helpful' height='30' multiple chips dense outlined  :placeholder='$t("GPT_USER_ANALYSIS.HELPFUL")' :items='helpful_cate' item-value='level' item-text='name')
                  template(v-slot:prepend-item)
                    v-list-item(ripple @mousedown.prevent @click="toggle_helpful")
                      v-list-item-action
                        v-icon(:color="selected_helpful.length > 0 ? 'indigo darken-4' : ''") {{ icon(selected_helpful, helpful_cate) }}
                      v-list-item-content
                        v-list-item-title {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    v-divider(class="mt-2")
                  template(v-slot:selection="{ item, index }")
                    //- 如果有全選、只顯示 All chip
                    v-chip(v-if="likeAll(selected_helpful,helpful_cate) && index === 0 ")
                      span {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    template(v-else)
                      v-chip(v-if="index === 0")
                        span {{ item.name }}
                      span(v-if="index === 1 && !likeAll(selected_helpful, helpful_cate) " class="grey--text text-caption" style="font-size: 8px;") +{{ selected_helpful.length - 1 }}
              //關聯度
              v-col(cols='3').px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.RELEVANCY')}}
                v-select.bg-white.my-chips-select(v-model='selected_relevance' height='30' multiple chips dense outlined  :placeholder='$t("GPT_USER_ANALYSIS.RELEVANCY")' :items='level_select' item-value='level' item-text='name')
                  template(v-slot:prepend-item)
                    v-list-item(ripple @mousedown.prevent @click="toggle_relevance")
                      v-list-item-action
                        v-icon(:color="selected_relevance.length > 0 ? 'indigo darken-4' : ''") {{ icon(selected_relevance, level_select) }}
                      v-list-item-content
                        v-list-item-title {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    v-divider(class="mt-2")
                  template(v-slot:selection="{ item, index }")
                    //- 如果有全選、只顯示 All chip
                    v-chip(v-if="likeAll(selected_relevance,level_select) && index === 0 ")
                      span {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    template(v-else)
                      v-chip(v-if="index === 0")
                        span {{ item.name }}
                      span(v-if="index === 1 && !likeAll(selected_relevance, level_select) " class="grey--text text-caption" style="font-size: 8px;") +{{ selected_relevance.length - 1 }}
              //準確度
              v-col(cols='3').px-0.ml-2
                div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('GPT_USER_ANALYSIS.ACCURACY')}}
                v-select.bg-white.my-chips-select(v-model='selected_accuracy' height='30' multiple chips dense outlined  :placeholder='$t("GPT_USER_ANALYSIS.ACCURACY")' :items='level_select' item-value='level' item-text='name')
                  template(v-slot:prepend-item)
                    v-list-item(ripple @mousedown.prevent @click="toggle_accuracy")
                      v-list-item-action
                        v-icon(:color="selected_accuracy.length > 0 ? 'indigo darken-4' : ''") {{ icon(selected_accuracy, level_select) }}
                      v-list-item-content
                        v-list-item-title {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    v-divider(class="mt-2")
                  template(v-slot:selection="{ item, index }")
                    //- 如果有全選、只顯示 All chip
                    v-chip(v-if="likeAll(selected_accuracy,level_select) && index === 0 ")
                      span {{ $t('GPT_USER_ANALYSIS.ALL') }}
                    template(v-else)
                      v-chip(v-if="index === 0")
                        span {{ item.name }}
                      span(v-if="index === 1 && !likeAll(selected_accuracy, level_select) " class="grey--text text-caption" style="font-size: 8px;") +{{ selected_accuracy.length - 1 }}
          v-col(cols="5").pa-0.pt-3
            v-row.ma-0.pa-0
              // 啟動篩選按鈕
              v-col(cols='2').px-0.ml-3
                v-btn.white--text(@click='act_search' height='40' :ripple='false' color='#14C6DE' depressed)
                  v-img.mr-1(src="../assets/images/search_btn_icon.png" max-height="18" max-width="18")
                  span(style='font-weight: 600; font-size: 16px;') {{$t('GENERAL.SEARCH')}}
              // 重置選擇按鈕
              v-col(cols='1').px-0.mr-8
                v-btn(text height='40' @click='refresh')
                  v-img.mr-1(src="../assets/images/refresh.png" max-height="16" max-width="16")
                  span(style="font-family: 'Segoe UI'; font-weight: 700; font-size: 16px; color: #14C6DE;") {{$t('GENERAL.REFRESH')}}
              v-col(cols='4').px-0.ml-4
                div.lib_search_bar_style
                  v-text-field(v-model='topic_search' flat dense append-icon='icon-search' rounded outlined style='width:100%;' hide-details)
        v-container.thread-analysis-container(max-content)
          v-data-table.dashboard-table.rounded-card.px-3.elevation-2.ml-2.mt-0(
            item-key="topic"
            :headers="fieldsHeader",
            :header-props="{sortIcon: 'mdi mdi-arrow-up'}",
            :items="questions_stats",
            :items-per-page="itemPerPage",
            :items-props="{class: 'UX-analysis-item'}"
            :page.sync="page",
            @page-count="pageCount = $event",
            multi-sort
            fixed-header,
            hide-default-footer="hide-default-footer",
            height='585px'
            :loading='loading'
            loading-text='Loading . . .'
            @click:row="select_drawer($event)"

          )
            template(v-slot:item.date="{ item }")
              .ellipsis.UX-analysis-item(:title= 'getFormatTime(item.created_on)')
                span {{ getFormatTime(item.created_on) }}

            template(v-slot:item.question="{ item }")
              .ellipsis.UX-analysis-item(:title='item.question')
                span {{ item.question }}

            template(v-slot:item.answer="{ item }")
              .ellipsis.UX-analysis-item(:title='item.answer')
                span {{ item.answer }}

            template(v-slot:item.feedback="{ item }" )
              .ellipsis.UX-analysis-item(:title='item.feedback')
                v-img(
                  v-if="item.feedback === 'Helpful'"
                  :src="require('../assets/images/good.svg')"
                  max-height="24"
                  max-width="24"
                  contain
                  style="margin:auto"
                )
                v-img(
                  v-else-if="item.feedback === 'Unhelpful'"
                  :src="require('../assets/images/bad.svg')"
                  max-height="24"
                  max-width="24"
                  contain
                  style="margin:auto"

                )
            template(v-slot:item.relevance="{ item }")
              .ellipsis.UX-analysis-item(:title='(item.relevance * 20).toFixed(2)')
                span {{ (item.relevance*20).toFixed(0) }}%

            template(v-slot:item.accuracy="{ item }")
              .ellipsis.UX-analysis-item(:title='(item.accuracy * 20).toFixed(2)')
                span {{ (item.accuracy * 20).toFixed(0) }}%

            template(v-slot:item.citation_count="{ item }")
              .ellipsis.UX-analysis-item(:title='item.citation_count')
                span {{ item.citation_count }}
            template(v-slot:body.append v-if='!loading')
              tr
                td(:colspan="fieldsHeader.length")
                  .v-row.d-flex.align-center.justify-center
                    .v-col-auto.d-flex.align-center
                      //span.mr-2.UX-analysis-item Rows per page:
                      //v-select(
                      //  v-model="itemPerPage"
                      //  :items="[5, 10, 15, 20, 25, 50]"
                      //  dense
                      //  hide-details
                      //  style="width: 60px;"
                      //  @change="page = 1"
                      //)
                      //.d-flex.align-center.grey--text.text--darken-1.ml-5.mr-3
                      //  span.UX-analysis-item {{ pageRangeText }}
                      v-pagination(
                        v-model='page'
                        :length='pageCount'
                        circle
                        :total-visible="10"
                        next-icon="mdi-menu-right"
                        prev-icon="mdi-menu-left"
                      )

    v-navigation-drawer.drawerShadow(v-model='openDrawer' absolute right hide-overlay :width="400" style='z-index: 21;')
      thread-analysis-dialog(@emitThreadAnalysisDrawer='onEmitThreadAnalysisDrawer' :check-thread="reference_detail")
    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    v-dialog(v-model='addDialog' width='480' content-class='statusDialog' v-if='addDialog')
      add-dialog(@emitAddDialog='onEmitAddDialog')

</template>

<script>
import loadingOverlay from "@/components/Common/loadingOverlay";
import messageDialog from "@/components/Dialog/messageDialog";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import addDialog from "@/components/GPT_Dialog/Knowledge/addKnowledge";
import i18n from '/common/plugins/vue-i18n.js';
import barChart from '../assets/script/barChart';
import KnowledgeLibraryService from "../services/KnowledgeLibraryService";
import PersonalSettingService from "@/services/PersonalSettingService";
import UpGPTDataService from "../services/UpGPTDataService";
import threadAnalysisDialog from "../components/GPT_Common/threadAnalysisDialog.vue";
import DatePicker from 'vue2-datepicker';

export default {
  components: {
    barChart,
    loadingOverlay,
    messageDialog,
    successDialog,
    errorDialog,
    addDialog,
    threadAnalysisDialog,
    DatePicker,
  },
  props: {
  },
  data() {
    return {
      // other
      loading:false,
      isDelete:false,
      breadcrumbs: [{
          text: i18n.t('GPT_MENU.BACKTO') + i18n.t('GPT_MENU.USER_ANALYSIS'),
          disabled: false,
          href: '/upgpt/UserAnalysis',
          }
      ],
      // Dialog
      addDialog:false,
      messageDialog: false,
      message: "",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      // Data
      Knowledges_list:[],
      filter_knowledges_list:[],
      botList:[],
      deleteId:null,
      bot_background_colors: ['#9ACFFF', '#F6C2C2', '#DEC5F6', '#9ACFFF', '#F6C2C2', '#DEC5F6' ],
      user_list:[],
      category_list: [],
      selectCategory: null,
      selectUpdateby: null,
      libname_search:'',
      fieldsHeader: [
        { text: i18n.t('GPT_THREAD_ANALYSIS.DATE'), value: "date", align: "left", width: '15%', sortable: true, class:'UX-analysis-header',
          sort: (a, b) => {
          const dateObjA = new Date(a);
          const dateObjB = new Date(b);
                return dateObjA - dateObjB;
          }
        },
        { text: i18n.t('GPT_THREAD_ANALYSIS.THREAD_NAME'), value: "question", width: '16%', sortable: true, class:'UX-analysis-header'},
        { text: i18n.t('GPT_THREAD_ANALYSIS.ANSWER'), value: "answer", align: "left", width: '33%', sortable: true, class:'UX-analysis-header'},
        { text: i18n.t('GPT_THREAD_ANALYSIS.HELPFUL'), value: "feedback", align: "center", width: '8%', sortable: true,class:'UX-analysis-header'},
        { text: i18n.t('GPT_THREAD_ANALYSIS.RELEVANCY'), value: "relevance", align: "left", width: '8%', sortable: true, class:'UX-analysis-header'},
        { text: i18n.t('GPT_THREAD_ANALYSIS.ACCURACY'), value: "accuracy", align: "left", width: '8%', sortable: true, class:'UX-analysis-header'},
        { text: i18n.t('GPT_THREAD_ANALYSIS.FILES'), value: "citation_count", align: "left", width: '5%', sortable: true, class:'UX-analysis-header'},

      ],
      //UserAnalysis
      topic_list:[],
      selected_topic:this.$route.params.name,
      questions_stats:[],
      page: 1,
      pageCount: 1,
      itemPerPage: 10,
      openDrawer: false,
      date_cate:[{date:0,name:i18n.t('GPT_USER_ANALYSIS.TODAY')},{date:1,name:i18n.t('GPT_USER_ANALYSIS.THIS_WEEK')},{date:3,name:i18n.t('GPT_USER_ANALYSIS.LAST_7_DAYS')},{date:2,name:i18n.t('GPT_USER_ANALYSIS.THIS_MONTH')},{date:4,name:i18n.t('GPT_USER_ANALYSIS.DATE_RANGE')}],
      helpful_cate:[{level:0,name:i18n.t('GPT_USER_ANALYSIS.HELPFUL')},{level:1,name:i18n.t('GPT_USER_ANALYSIS.UNHELPFUL')},{level:2,name:i18n.t('GPT_THREAD_ANALYSIS.NO_FEEDBACK')}],
      level_select:[{level:0,name:"0~20%"},{level:1,name:"21~40%"}, {level:2,name:"41~60%"},{level:3,name:"61~80%"},{level:4,name:"81~100%"}],
      selected_date_type: 3,
      select_start_date: '',
      select_end_date: '',
      selectDate:'',
      selectDateText:'',
      selected_relevance:[0,1,2,3,4],
      selected_accuracy:[0,1,2,3,4],
      selected_helpful:[0,1,2],
      feed_back_para:["Helpful","Unhelpful"],
      selected_ask_null:1,
      relevance_para:null,
      accuracy_para:null,
      like_all_relevance:false,
      like_all_accuracy:false,
      startDate: null,
      endDate: null,
      topic_search:'',
      selected_question_id: "",
      reference_detail:{},
      default_topic: ""
    };
  },
  async created() {
    this.loading = true;
    await this.get_time()
    await this.get_questions_statistics()
    await this.get_all_topic()
    await PersonalSettingService.getUserDetail().then(response => {
      if (response.data && response.data.userList.length > 0) {
        let temp_arr = [];
        let temp_data = {};
        let user_data = response.data.userList;
        user_data.filter(el => {
          temp_data = {};
          if(el.is_active == true){
            temp_data['id'] = el.id;
            temp_data['name'] = el.last_name+' '+el.first_name;
            temp_arr.push(temp_data);
          }
        });
        this.user_list = temp_arr
      }
    })
    .catch((response) => {
        this.showErrorDialog(response);
    });
    this.loading = false;
    this.default_topic = this.selected_topic;
  },
  destroyed() {
  },
  computed:{
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: false
        }
      };
    },
    pageRangeText() {
    const start = (this.page - 1) * this.itemPerPage + 1;
    const end = Math.min(start + this.itemPerPage - 1, this.questions_stats.length);
    const total = this.questions_stats.length;
    return `${start}-${end} of ${total}`;
    }
  },
  methods: {
    get_time(){
      this.selected_date_type= parseInt(this.$route.query.date_type);
      this.select_start_date = this.$route.query.start_date;
      this.select_end_date = this.$route.query.end_date;
      const { start_date, end_date } =  this.getDateRange(this.selected_date_type);
      this.startDate = start_date;
      this.endDate = end_date;
    },
    async get_questions_statistics() {
      // Prepare request data
      const topic = []
      topic.push(this.selected_topic)
      const requestData = {
        ...(this.startDate != null && { start_date: this.startDate }),
        ...(this.endDate != null && { end_date: this.endDate }),
        topic: topic,
        ...(this.feed_back_para!= null && {feedback:this.feed_back_para}),
        ...(this.selected_relevance!= null && {relevance:this.selected_relevance}),
        ...(this.selected_accuracy!= null && {accuracy:this.selected_accuracy}),
        ...(this.selected_ask_null!=null &&{asknull:this.selected_ask_null}),
        ...(this.topic_search!='' &&{words:this.topic_search})
      };
      try {
        console.log(requestData)
        const response = await UpGPTDataService.get_questions_statistics_by_topic(requestData);
        this.questions_stats = response.data.map(item =>{
          item.date = `${item.Month}/${item.Day}`;
          return item;
        });
        this.loading = false;
      } catch (error) {
        this.showErrorDialog(error);
        this.loading = false;
      }
    },
    async get_all_topic(){
      await  UpGPTDataService.get_all_distinct_topic().then((response)=>{
        this.topic_list = response.data;
      })
    },
    async select_drawer(data){
      this.openDrawer = true;
      this.selected_question_id = data.id;
      const requestData = {
              message_id: this.selected_question_id
            };
      UpGPTDataService.get_question_refence_by_question(requestData).then(response => {
        this.reference_detail = response.data;
        this.reference_detail.accuracy = this.reference_detail.accuracy*20
        this.reference_detail.relevance = this.reference_detail.relevance*20
      })
      .catch((response) => {
        this.showErrorDialog(response);
      });
      console.log("Open Drawer: ", data)
    },
    getFormatTime(data){
        let today  = new Date(data);
        if(this.$i18n.locale == "zh_TW")
        {
          let year = today.getFullYear();
          let month = today.getMonth() + 1; // 月份從0開始
          let day = today.getDate();
          let date = `${year}/${month}/${day}`;
          let weekday = today.toLocaleDateString("zh-TW", { weekday: 'long' });
          let time = today.toLocaleTimeString("zh-TW", { hour: "2-digit", minute: "2-digit", hour12: false });
          return `${date} ${weekday} ${time}`;
        }else
        {
          let dateStr = today.toLocaleDateString("en-US", { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
          let time = today.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false });
          return `${dateStr} ${time}`;
        }
    },
    // Filter Area ---------------------------------------- [Start]
    dateChange(val){
      this.selectDateText = val.join(" ~ ");
      console.log("SelectDate :", val)
      this.select_start_date = val[0];
      this.select_end_date = val[1];
    },
    toggle_helpful() {
      this.$nextTick(() => {
        if (this.likeAll(this.selected_helpful, this.helpful_cate)) {
          this.selected_helpful = []
        } else {
          this.selected_helpful = this.helpful_cate.map(item => item.level)
        }
      })
    },
    toggle_relevance() {
      this.$nextTick(() => {
        if (this.likeAll(this.selected_relevance, this.level_select)) {
          this.selected_relevance = []
        } else {
      this.selected_relevance = this.level_select.map(item => item.level)
        }
      })
    },
    toggle_accuracy() {
      this.$nextTick(() => {
        if (this.likeAll(this.selected_accuracy, this.level_select)) {
          this.selected_accuracy = []
        } else {
          this.selected_accuracy = this.level_select.map(item => item.level)
        }
      })
    },
    likeAll(selected,item){
      return selected.length === item.length
    },
    likesome(seleected,item){
      return seleected.length > 0 && !this.likeAll(seleected,item)
    },
    icon(selected,item){
      if (this.likeAll(selected,item)){
        return 'mdi-close-box'
      }
      else if(this.likesome(selected,item)){ return 'mdi-minus-box'}
      else{
        return 'mdi-checkbox-blank-outline'
      }
    },
    getDateRange(type) {
      const now = new Date();

      let start_date, end_date;
      function pad(n) { return n.toString().padStart(2, '0'); }
      function format(dateObj, h = '00', m = '00', s = '00') {
        // 轉換成 yyyy-mm-ddThh:mm:ss
        return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())}T${h}:${m}:${s}`;
      }
      if (type === 0) {
        // 今天
        start_date = format(now, '00', '00', '00');
        end_date = format(now, '23', '59', '59');

      }
      else if (type === 1) {
        // 這週
        const day = now.getDay(); // 0(日)~6(六)
        const mondayOffset = day === 0 ? -6 : 1 - day; // 本週一
        const sundayOffset = day === 0 ? 0 : 7 - day; // 本週日
        // 週一
        const first = new Date(now);
        first.setDate(first.getDate() + mondayOffset);
        // 週日
        const last = new Date(now);
        last.setDate(last.getDate() + sundayOffset);

        start_date = format(first, '00', '00', '00');
        end_date = format(last, '23', '59', '59');

      } else if (type === 2) {
        // 這月
        // 月初
        const first = new Date(now.getFullYear(), now.getMonth(), 1);
        const last = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 下個月的第0天=本月最後一天

        start_date = format(first, '00', '00', '00');
        end_date = format(last, '23', '59', '59');
      } else if (type === 3) {
        // 過去七天
        const now = new Date();

        // 過去七天：End=今天, Start=今天-6天
        const end = new Date(now);         // 今天
        const start = new Date(now);
        start.setDate(start.getDate() - 6);

        start_date = format(start, '00', '00', '00');   // 這6天前的 00:00:00
        end_date = format(end, '23', '59', '59');       // 今天的 23:59:59

      }else if (type === 4) {
        // 自訂
        const start = new Date(this.select_start_date)
        const end = new Date(this.select_end_date)
        start_date = format(start, '00', '00', '00');   // 這6天前的 00:00:00
        end_date = format(end, '23', '59', '59');       // 今天的 23:59:59

      } else {
        throw new Error('未知type');
      }

      return {start_date, end_date };
    },
    format_feedback(){
      this.feed_back_para = [];
      this.selected_ask_null = 0;
      if(this.selected_helpful.includes(0)){
        this.feed_back_para.push("Helpful");
      }
      if(this.selected_helpful.includes(1)){
        this.feed_back_para.push("Unhelpful");
      }
      if(this.selected_helpful.includes(2)){
        this.selected_ask_null = 1;
      }
    },
    // Dialog Area ----------------------------------------- [Start]
    onEmitThreadAnalysisDrawer(){
      this.openDrawer = false;
    },
    showAddDialog() {
      this.addDialog = true;
    },
    onEmitAddDialog(val,data){
      if(val){
        data.robots = data.linked_bots_and_knowledge_set.map(item=> {return item.ai_bot_id});
        data.robots_count = data.linked_bots_and_knowledge_set.length;
        data.docs_count = data.knowledge_detial_set.length;
        this.Knowledges_list.unshift(data);
        this.act_search();
      }
      this.addDialog = false;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    showMessageDialog(message) {
      this.messageDialog = true;
      this.message = message;
    },
    async onEmitMessageDialog(val) {
      if(val && this.isDelete){
          await KnowledgeLibraryService.delete(this.deleteId).then(()=>{
            this.Knowledges_list = this.Knowledges_list.filter(el=>el.id != this.deleteId)
            this.act_search();
        })
      }
      this.isDelete = false;
      this.deleteId = null,
      this.messageDialog = false;
    },
    async act_search() {
      if (this.selected_date_type === 4 && (!this.select_start_date || !this.select_end_date)) {
          this.showErrorDialog(this.$t('GPT_USER_ANALYSIS.SELECT_DATE_RANGE_ERROR'));
      return;
      }
      const { start_date, end_date } =  this.getDateRange(this.selected_date_type);
      this.startDate = start_date;
      this.endDate = end_date;
      this.format_feedback();
      this.replace_url();
      await this.get_questions_statistics();
      this.questions_stats = [...this.questions_stats];
    },
    async refresh(){
      this.selected_date_type = 3;
      this.selected_topic = this.default_topic;
      this.selected_relevance = [0,1,2,3,4];
      this.selected_accuracy = [0,1,2,3,4];
      this.selected_helpful = [0,1,2]
      this.feed_back_para = ["Helpful","Unhelpful"];
      this.selected_ask_null = 1;
      this.topic_search = '';
      this.act_search();
    },
    replace_url(){
        let query = {};

        if (this.selected_date_type == 4) {
          query = {
            date_type: this.selected_date_type,
            start_date: this.select_start_date,
            end_date: this.select_end_date
          };
        } else {
          query = {
            date_type: this.selected_date_type
          };
        }
        this.$router.replace({
          path: `/upgpt/UserAnalysis/${this.selected_topic}`,
          query: query
        });
    },
    },
  watch:{
    "messageDialog":function(){
      if(!this.messageDialog){
        this.isDelete = false;
      }
    },
    "topic_search":function(){
      this.act_search();
    },
  }

};
</script>
<style scoped>
/* 確保表格內容也靠左對齊 */
.v-data-table tbody td {
  text-align: left !important;
}
.knowledgelib-in-threadanalysis-chip {
    max-width: 100px !important;
    max-height: 30px !important;
}
</style>